// Imports
import { createSlice } from '@reduxjs/toolkit';
import { HubModel, VendorModel } from '../components/utils/Models';
import { SliceNames, DefaultSliceData } from "../config/Constants";

// Interfaces for slice state
interface VendorProfileSliceState {
  loginStatus: boolean;
  token: string;
  profile: VendorModel;
  hubs: HubModel[]
}

// Create slice
export const vendorProfileSlice = createSlice({
  name: SliceNames.VENDOR_PROFILE,
  initialState: {
    loginStatus: false,
    token: '',
    profile: DefaultSliceData.VENDOR_PROFILE as VendorModel,
    hubs: [] as HubModel[]
  },
  reducers: {
    setVendorLoginToken(state: VendorProfileSliceState, action) {
      state.token = action.payload;
      state.loginStatus = true;
    },
    setVendorLoginStatus(state: VendorProfileSliceState, action) {
      state.loginStatus = action.payload;
    },
    setVendorProfile(state: VendorProfileSliceState, action) {
      state.profile = action.payload;
    },
    setVendorHubs(state: VendorProfileSliceState, action) {
      state.hubs = action.payload;
    },
  },
});

// Export state actions for this slice
export const { setVendorProfile, setVendorLoginStatus, setVendorHubs, setVendorLoginToken } = vendorProfileSlice.actions;

// Export state getters for this slice
export const getVendorProfile = (state: any): VendorModel => state[SliceNames.VENDOR_PROFILE].profile;
export const getVendorHubs = (state: any): HubModel[] => state[SliceNames.VENDOR_PROFILE].hubs;
export const getVendorToken = (state: any): string => state[SliceNames.VENDOR_PROFILE].token;
export const getVendorLoginStatus = (state: any): boolean => state[SliceNames.VENDOR_PROFILE].loginStatus;

// Export reducer
export const vendorProfileReducer = vendorProfileSlice.reducer;